import component from './projectsSave.vue'

export default component
